export default class DashboardTrendDefinition {
    constructor(id, column, localizedLabel, greenTrendOnPositiveData) {
        this._id = id;
        this._column = column;
        this._localizedLabel = localizedLabel;
        this._greenTrendOnPositiveData = greenTrendOnPositiveData;
    }

    get id() {
        return this._id;
    }

    get column() {
        return this.column;
    }

    get localizedLabel() {
        return this.localizedLabel;
    }

    get greenTrendOnPositiveData() {
        return this.greenTrendOnPositiveData;
    }
}
